import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "card-marks",
  role: "img",
  "aria-label": "Accepted cards"
}
const _hoisted_2 = {
  key: 0,
  viewBox: "0 0 48 32",
  class: "cm",
  "aria-label": "Visa"
}
const _hoisted_3 = {
  key: 1,
  viewBox: "0 0 48 32",
  class: "cm",
  "aria-label": "Mastercard"
}
const _hoisted_4 = {
  key: 2,
  viewBox: "0 0 48 32",
  class: "cm",
  "aria-label": "American Express"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_ctx.has('visa'))
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("rect", {
            width: "48",
            height: "32",
            rx: "4",
            fill: "#fff",
            stroke: "#e6e6e6"
          }, null, -1),
          _createElementVNode("text", {
            x: "24",
            y: "21",
            "text-anchor": "middle",
            "font-family": "Arial, sans-serif",
            "font-size": "12.5",
            "font-weight": "700",
            "font-style": "italic",
            "letter-spacing": "0.5",
            fill: "#1A1F71"
          }, "VISA", -1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.has('mastercard'))
      ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _cache[1] || (_cache[1] = [
          _createElementVNode("rect", {
            width: "48",
            height: "32",
            rx: "4",
            fill: "#fff",
            stroke: "#e6e6e6"
          }, null, -1),
          _createElementVNode("circle", {
            cx: "20",
            cy: "16",
            r: "9",
            fill: "#EB001B"
          }, null, -1),
          _createElementVNode("circle", {
            cx: "28",
            cy: "16",
            r: "9",
            fill: "#F79E1B"
          }, null, -1),
          _createElementVNode("path", {
            d: "M24 9.4a9 9 0 0 1 0 13.2 9 9 0 0 1 0-13.2z",
            fill: "#FF5F00"
          }, null, -1)
        ])))
      : _createCommentVNode("", true),
    (_ctx.has('amex'))
      ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[2] || (_cache[2] = [
          _createElementVNode("rect", {
            width: "48",
            height: "32",
            rx: "4",
            fill: "#2E77BC"
          }, null, -1),
          _createElementVNode("text", {
            x: "24",
            y: "20",
            "text-anchor": "middle",
            "font-family": "Arial, sans-serif",
            "font-size": "7.5",
            "font-weight": "700",
            fill: "#fff",
            "letter-spacing": "0.3"
          }, "AMEX", -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}